<template>
  <div class="efficiency-viz-pro">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>η = W有 / W总$</div>
    </div>

    <div class="main-layout vertical">
      <!-- 动态比例图 -->
      <div class="chart-area">
        <div class="energy-stack">
           <div class="useful-energy" :style="{ flex: usefulRatio }">
              <span class="label">有用功 W_useful: {{ (usefulRatio * 100).toFixed(0) }}%</span>
              <div class="pulse-glow"></div>
           </div>
           <div class="loss-energy" :style="{ flex: 1 - usefulRatio }">
              <span class="label">额外功 W_loss: {{ ((1 - usefulRatio) * 100).toFixed(0) }}%</span>
           </div>
        </div>
        
        <div class="efficiency-gauge">
           <svg width="120" height="120" viewBox="0 0 100 100">
              <circle cx="50" cy="50" r="45" fill="none" stroke="rgba(255,255,255,0.05)" stroke-width="8" />
              <circle cx="50" cy="50" r="45" fill="none" :stroke="gaugeColor" stroke-width="8" stroke-dasharray="283" :stroke-dashoffset="283 * (1 - usefulRatio)" stroke-linecap="round" />
              <text x="50" y="55" text-anchor="middle" :fill="gaugeColor" font-size="16" font-weight="bold">{{ (usefulRatio * 100).toFixed(0) }}%</text>
           </svg>
           <div class="gauge-label">系统总效率 η</div>
        </div>
      </div>

      <!-- 控制面板 -->
      <div class="bottom-controls">
         <div class="control-card glass">
            <div class="s-row">
               <label>轴承摩擦力 (额外功来源)</label>
               <el-slider v-model="friction" :min="5" :max="80" size="mini"></el-slider>
            </div>
            <div class="s-row">
               <label>提升负荷 (有用功占比)</label>
               <el-slider v-model="load" :min="20" :max="200" size="mini"></el-slider>
            </div>
         </div>

         <div class="analysis-card">
            <div class="title"><i class="el-icon-data-analysis"></i> 效率分析报告</div>
            <p><strong>现状：</strong>当前额外功主要来源于组件自重与摩擦。<strong>优化建议：</strong>增加载荷或减小摩擦（如添加润滑油）可显著提升效率。</p>
         </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MechanicalEfficiencyViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      friction: 20,
      load: 100
    }
  },
  computed: {
    usefulRatio() {
      const total = this.load + this.friction;
      return this.load / total;
    },
    gaugeColor() {
      if (this.usefulRatio > 0.8) return '#2ed573';
      if (this.usefulRatio > 0.6) return '#00d2ff';
      return '#ff4757';
    }
  }
}
</script>

<style scoped lang="scss">
.efficiency-viz-pro {
  flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden;
}

.viz-header {
  display: flex; justify-content: space-between; align-items: center;
  .title { font-size: 1.1rem; color: #fff; font-weight: 300; }
  .formula-chip { padding: 4px 12px; background: rgba(46, 213, 115, 0.1); border-radius: 8px; color: #2ed573; font-family: serif; font-weight: bold; }
}

.chart-area {
  flex: 1.2; display: flex; align-items: center; gap: 30px; padding: 20px; background: rgba(0,0,0,0.3); border-radius: 12px; border: 1px solid rgba(255,255,255,0.05);
  
  .energy-stack {
     flex: 1; height: 160px; display: flex; flex-direction: column; border-radius: 8px; overflow: hidden; border: 1px solid rgba(255,255,255,0.1);
     .useful-energy { background: linear-gradient(to bottom, #2ed573, #1e90ff); display: flex; align-items: center; justify-content: center; position: relative; overflow: hidden; .label { color: #fff; font-size: 0.75rem; font-weight: bold; z-index: 1; } }
     .loss-energy { background: rgba(255, 71, 87, 0.2); display: flex; align-items: center; justify-content: center; .label { color: #ff6b6b; font-size: 0.7rem; } }
     .pulse-glow { position: absolute; top: -100%; left: 0; width: 100%; height: 100%; background: linear-gradient(transparent, rgba(255,255,255,0.2), transparent); animation: sweep 2s infinite; }
  }
  
  .efficiency-gauge {
     width: 120px; text-align: center;
     .gauge-label { margin-top: 10px; font-size: 0.7rem; color: #888; text-transform: uppercase; }
  }
}

.bottom-controls {
  flex: 0.8; display: flex; flex-direction: column; gap: 12px; overflow-y: auto; padding-bottom: 15px;
}

.control-card {
  background: rgba(255, 255, 255, 0.03); border-radius: 12px; padding: 18px;
  .s-row { margin-bottom: 12px; &:last-child { margin-bottom: 0; } label { display: block; font-size: 0.75rem; color: #aaa; margin-bottom: 8px; } }
}

.analysis-card {
  background: rgba(46, 213, 115, 0.05); border-radius: 12px; padding: 15px; border-left: 3px solid #2ed573;
  .title { font-size: 0.85rem; color: #2ed573; margin-bottom: 8px; font-weight: bold; }
  p { margin: 0; font-size: 0.75rem; color: #888; line-height: 1.5; strong { color: #fff; } }
}

@keyframes sweep { from { top: -100%; } to { top: 100%; } }
</style>
